import authActions from './auth.js';
import emailVerificationActions from './emailVerification.js';
import mfaActions from './mfa.js';
import otpActions from './otp.js';
import ssoActions from './sso.js';

export default {
  ...authActions,
  ...emailVerificationActions,
  ...mfaActions,
  ...otpActions,
  ...ssoActions,
};
